import React from "react";
import { ItemGroup, ItemSelect, ItemSelectProps } from './item-select';
import '../styles/index.scss';
export const renderWorkItemLabel = (workitem: CMxAPI.WorkItem) => {
  return (workitem.data as any)?.assignee;
};

export const renderWorkitemInItemSelector = (workitem: CMxAPI.WorkItem) => {
  return <div>{(workitem.data as any)?.assignee}</div>;
};

enum WorkItemStatus {
  IN_CQA = 'IN PROGRESS',
  CQA_COMPLETE = 'COMPLETE',
  CQA_APPROVED = 'APPROVED'
}

export const GroupWorkitemsByStatus = (
  workitems: CMxAPI.WorkItem[]
): ItemGroup<CMxAPI.WorkItem>[] => {
  // Create new groups array with empty items arrays each time
  const groups: ItemGroup<CMxAPI.WorkItem>[] = [
    {
      label: WorkItemStatus.IN_CQA,
      items: []
    },
    {
      label: WorkItemStatus.CQA_COMPLETE,
      items: []
    },
    {
      label: WorkItemStatus.CQA_APPROVED,
      items: []
    }
  ];

  workitems.forEach(workitem => {
    const qaStatus = workitem.data.qa_status;
    const group = groups.find(
      group => group.label === WorkItemStatus[qaStatus]
    );
    if (group) {
      group.items.push(workitem);
    }
  });

  return groups;
};

export const isWorkitemSelected = (
  selectedWorkitem: CMxAPI.WorkItem,
  currentWorkitem: CMxAPI.WorkItem
) => {
  return selectedWorkitem?.data?.case_id === currentWorkitem.data?.case_id;
};

export const getSelectedWorkitemFromInvoice = (
  cursorAPIContext: CMxCommonApp.CursorAPIContext,
  workitems: CMxAPI.WorkItem[]
): [CMxAPI.WorkItem, number] => {
  const selectedWorkitemIndex = workitems.findIndex(
    workitem => workitem.data.case_id === cursorAPIContext.workitemId
  );
  return [workitems[selectedWorkitemIndex], selectedWorkitemIndex];
};
